var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13 18",
    enableBackground: "new 0 0 13 18",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#003366",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M1,16.1 C1,16.6,1.4,17,1.9,17h9.1c0.5,0,0.9-0.4,0.9-0.9V1H1L1,16.1z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#003366",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 3.5,
    y1: 4,
    x2: 9.5,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#003366",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 3.5,
    y1: 12,
    x2: 9.5,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#003366",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 3.5,
    y1: 14.5,
    x2: 9.5,
    y2: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#003366",
    cx: 6.5,
    cy: 8.3,
    r: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.b08867a2f9c4ef7746f7d18fe24cb9fa.svg";
export { ForwardRef as ReactComponent };